module.exports = __webpack_public_path__ + "static/media/logo-saiems-negativo.fb2712a7.svg";